const formatterCache = new Map();

function getFormatter(isInteger, fractionDigits) {
  const key = `${isInteger}-${fractionDigits}`;

  if (!formatterCache.has(key)) {
    formatterCache.set(
        key,
        new Intl.NumberFormat('en-US', {
          style: 'decimal',
          minimumFractionDigits: isInteger ? 0 : fractionDigits,
          maximumFractionDigits: fractionDigits,
        }),
    );
  }

  return formatterCache.get(key);
}

export default function formatNumber(value, fractionDigits = 2) {
  if (value == null) return '';

  const isInteger = Number.isInteger(value);
  const formatter = getFormatter(isInteger, fractionDigits);

  return formatter.format(value);
}
